import { UseQueryResult } from '@tanstack/react-query';
import { DexResultsView } from '@mark43/dex-api';
import { useBroadcast } from '../../common/broadcast-channel/use-broadcast';
import { DexResultsStore } from './dex-results-store';

export function useDexResultsBroadcastListener(
    dexResultsStore: DexResultsStore,
    getDexResultsQuery: UseQueryResult<DexResultsView[] | undefined, unknown>
) {
    useBroadcast('dex-results', (message) => {
        if (message.type === 'DISMISS_DEX_NOTIFICATIONS') {
            dexResultsStore.setLatestSeenDexIncomingMessageId(
                message.payload.latestSeenDexIncomingMessageId
            );
        } else if (message.type === 'REFETCH_DEX_RESULTS') {
            getDexResultsQuery.refetch();
        } else if (message.type === 'READ_DEX_RESULT') {
            dexResultsStore.readResult(message.payload.incomingMessageId);
        } else if (message.type === 'READ_DEX_RESULTS_SUMMARY') {
            dexResultsStore.readSummary(message.payload.outgoingMessageId);
        }
    });
}
